import React, {useRef, useState, Fragment} from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from "./ModalContentWrapper";
import {getDataWithPromise} from "../DataFunctions/BaseDataFns";

import './TwoColumnModal.scss';
import UserInput from "../UI/ReactUserInput";
import SpinnerDiv from "ui/SpinnerDiv";

const ModalGenerateReviews = (props) =>
{
    const [params, setParams] = useState(props.params);
    const [generating, setGenerating] = useState ( false ) ;

    const [displayErrors, setError] = useState(false);

    const dateRef = useRef(null);

    const primaryButtonStyle = {
        marginRight: '10px',
        marginLeft: '10px'
    };

    const doUpdate = ( date, onComplete ) =>
    {
        setGenerating(true);
        const url = Globals.APIFolder + '/reviews/term/' + props.year_term_id ;

        getDataWithPromise ( url, 'PUT', { deadline_date: date } ).then (response =>
        {
            setGenerating(false);
            if ( onComplete !== null )
            {
                onComplete( response );
            }
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            setGenerating(false);
            handleAjaxError( jqXHR, textStatus, error) ;
        });
    }

    const onClickGenerate = () =>
    {
        const date = dateRef.current.getValue() ;

        if ( date === '' )
        {
            setError( true ) ;
        }
        else
        {
            doUpdate( date, props.onSaveCompleted )
        }
    }

    const onClickCancel = () =>
    {
        props.onClose() ;
    }

    const formContent = () =>
    {
        if ( generating )
        {
            return (
                <div style={{ textAlign: 'center', color: 'var(--vschool-mild-blue)', marginTop: '10px'}}>
                    <h4>Generating Requests</h4>
                    <h5 style={{color: 'var(--vschool-mild-red)'}}>Please Wait - Do Not Refresh Your Screen</h5>
                    <SpinnerDiv/>
                </div>
            )
        }
        else
            return (
                <Fragment>
                    <div className='buy-card-right'>
                        <p>You are about to send progress Review requests to ALL of the Designated Teachers for this term.</p>
                        <p>This will send an email to all Desi Teachers asking for progress review feedback and create an inbox item for each of them.</p>
                        <p>If you are sure you want to do this, please select a deadline date from the dropdown below and click the 'Generate' button below</p>
                        <UserInput validation={{ required: true, maxlen: 10, isDate: true }}
                                   id= 'InputDateFrom'
                                   name = 'InputDateFrom'
                                   ref = {dateRef}
                                   labelText = 'Deadline Date'
                                   placeholder = 'DD/MM/YYYY'
                                   errorText = 'You must enter a valid date'
                                   value = ''
                                   readOnly ={false}
                                   displayErrors = {displayErrors}
                                   style={{marginBottom: '10px'}}/>

                    </div>
                    <button onClick={onClickCancel}
                            className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"></i></button>
                    <button onClick={onClickGenerate} style={primaryButtonStyle}
                            className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Generate Now<i className="et-check"></i></button>
                </Fragment>
            )
    }

    return (
        <ModalContentWrapper className="modal-wrapper" columns={2}>
            <h3>Generate Term Progress Review Requests</h3>
            <div className='buy-card'>
                <div>
                    <span className='glyphicon glyphicon-file' style={{color: 'var(--vschool-mild-blue)', fontSize: '15rem', marginTop: '30px'}}/>
                </div>
                {formContent()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalGenerateReviews ;

ModalGenerateReviews.propTypes = {
    params: PropTypes.object,
    user_id: PropTypes.string,
};
